module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title",
    attrs: {
      "id": "Introduction"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1",
      "title": "1"
    }
  }, [_vm._v("Introduction")])]), _c('a', {
    attrs: {
      "id": "page1",
      "title": "1"
    }
  }, [_c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "box-para1"
  }, [_vm._v("No more will the war cry sever,")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_vm._v("Or the inland rivers run red.")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_vm._v("We have buried our anger forever,")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_vm._v("In the sacred graves of the dead.")]), _vm._v(" "), _c('p', {
    staticClass: "box-para1"
  }, [_vm._v("Under the sod and the dew,")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_vm._v("Awaiting the Judgment Day.")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_vm._v("Love and tears for the blue!")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_vm._v("Tears and love for the gray!")]), _vm._v(" "), _c('p', {
    staticClass: "box-para1"
  }, [_vm._v("— Thomas Hughes, 1895")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("After")]), _vm._v(" all wars, reconciliation is difficult at first, but as monarchs and politicians responsible for the conflict age and die, the young combatants who survived the suffering and carnage remain and, in time, rightly become the most prominent influencers of the memory of the events. More often than not the men who attempted to kill each other eventually forgive their former foes. Anger and vengeance are replaced with respect for the trials and tribulations shared by the former adversaries. Most important, they respect the trait most admired by all soldiers: a former foe’s answer to the call of duty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Speaking in 1902 at a memorial service honoring Confederate soldiers who died at the Camp Chase prisoner-of-war camp in Columbus, Ohio, Union Army veteran and Grand Army of the Republic state commander Judge David Pugh said of Robert E. Lee’s defeated soldiers, “I pity the American who cannot be proud of their valor and endurance.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page1",
      "title": "1"
    }
  }), _c('a', {
    attrs: {
      "id": "page2",
      "title": "2"
    }
  }, [_vm._v("Theodore Roosevelt, whose two beloved uncles served the Confederate cause in the Civil War, addressed a gathering in Roswell, Georgia on October 20, 1905. “It has been my very great good fortune to have the right to claim my blood is half Southern and half Northern,” the young president said, “and I would deny the right of any man here to feel a greater pride in the deeds of every Southerner than I feel.” Roosevelt concluded his remarks by proclaiming,")])]), _c('a', {
    attrs: {
      "id": "page2",
      "title": "2"
    }
  }), _c('p', {
    staticClass: "bq"
  }, [_c('a', {
    attrs: {
      "id": "page2",
      "title": "2"
    }
  }, [_vm._v("I have the ancestral right to claim a proud kinship with those who showed their devotion to duty as they saw the duty, whether they wore the grey or whether they wore the blue. All Americans who are worthy of the name feel an equal pride in the valor of those who fought on one side or the other, provided only that each did with all his strength and soul and mind, his duty as he saw his duty."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn_2",
      "id": "fn2"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Similarly, noted author and Union veteran Ambrose Bierce wrote of unknown Confederate dead:")]), _vm._v(" "), _c('p', {
    staticClass: "bq"
  }, [_vm._v("They were honest and courageous foemen, having little in common with the political madmen who persuaded them to their doom and the literary bearers of false witness in the after time. They did not live through the period of honorable strife into the period of vilification—did not pass from the iron age to the brazen—from the era of the sword to that of the tongue and pen. Among them is no member of the Southern Historical Society. Their valor was not the fury of the non-combatant; they have no voice in the thunder of the civilians and the shouting. Not by them are impaired the dignity and infinite pathos of the Lost Cause. Give them, these blameless gentlemen, their rightful part in all the pomp that fills the circuit of the summer hills.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("— Ambrose Bierce, “A Bivouac of the Dead,” 1905")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("In the decades after the war the survivors of the continent’s bloodiest-ever conflict gradually reconciled and, for many, simple forgiveness morphed into a brotherly bond. One incident illustrative of the wave of late-life reconciliation between former enemies occurred in the unlikely setting of Martha’s Vineyard, Massachusetts, involving Charles Strahan, a former Confederate private in the 21st Virginia Infantry Regiment, and the local Union Army veterans of the Civil War.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the war Strahan moved to the town of Oak Bluffs on the island of Martha’s Vineyard, purchased the local newspaper, and, over the years, prospered. "), _c('a', {
    attrs: {
      "id": "page3",
      "title": "3"
    }
  }, [_vm._v("Not surprisingly, Strahan was the only Confederate veteran on the island, and he observed with admiration and respect the comradery of the local chapter of the Grand Army of the Republic (GAR), the fraternal organization of former Union soldiers of the Civil War. In 1891, using his own personal funds, Strahan erected a statue in the town square honoring the Union soldiers of the war; shortly before Strahan’s death in 1925, in a gesture of admiration and respect, the GAR chapter attached a plaque onto the statue’s pedestal that read,")])]), _c('a', {
    attrs: {
      "id": "page3",
      "title": "3"
    }
  }), _c('div', {
    staticClass: "box"
  }, [_c('a', {
    attrs: {
      "id": "page3",
      "title": "3"
    }
  }, [_c('p', {
    staticClass: "box-para"
  }, [_vm._v("“THE CHASM IS CLOSED”")]), _vm._v(" "), _c('p', {
    staticClass: "box-para1"
  }, [_vm._v("IN MEMORY OF THE RESTORED UNION")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_vm._v("THIS TABLET IS DEDICATED BY")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_vm._v("UNION VETERANS OF THE CIVIL WAR")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_vm._v("AND PATRIOTIC CITIZENS OF MARTHA’S VINEYARD")])]), _c('p', {
    staticClass: "box-para"
  }, [_c('a', {
    attrs: {
      "id": "page3",
      "title": "3"
    }
  }, [_vm._v("IN HONOR OF THE CONFEDERATE SOLDIERS"), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn_3",
      "id": "fn3"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The chasm referenced on the plaque had been largely closed twenty-seven years earlier in the Spanish-American War, the first military test for postwar America, when many Southerners were eager to prove their patriotism, if necessary, with their own blood. A former Confederate soldier wrote,")]), _vm._v(" "), _c('p', {
    staticClass: "bq"
  }, [_vm._v("When the Spanish-American War came on, the men of the blue and the men of the gray stood shoulder to shoulder, the sons of the men who wore the blue and the gray in 1861-65 marched step with step, and won the victory that made us proud that we were Americans. Our country was thus cemented together as never before, and prejudices gave way to an era of good feeling throughout this Union."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn_4",
      "id": "fn4"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("While the nation was still basking in the glow of the decisive victory over the Spanish empire, Congress acknowledged the vital part played by Southerners in the brief but momentous war. On January 26, 1903, a bill was introduced in the U.S. Senate by Senator Joseph Foraker of Ohio requesting $100,000 for headstones for Confederate soldiers who had died in Northern prisoner-of-war camps. The bill passed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("unanimously")]), _vm._v(" and is often cited as the genesis of the official reconciliation that had already permeated American society.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page4",
      "title": "4"
    }
  }, [_vm._v("Reconciliation, forgiveness, and expressions of mutual respect became common after the turn of the century. A postwar exchange of letters between a former Union soldier and a Confederate commander regarding the May 3-4, 1863, Battle of Salem Church (Virginia) vividly illustrates the personal affection shared by the former enemies, as well as the public’s desire to permanently honor the dedication and sacrifice of all Civil War soldiers.")])]), _c('a', {
    attrs: {
      "id": "page4",
      "title": "4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A monument had been erected near the Salem Church battlefield, with two plaques (one honoring Union soldiers, including those of the 23rd New Jersey Infantry Regiment), and one for Confederate soldiers (among them members of the 8th Alabama Infantry Regiment including Lieutenant Colonel Hilary A. Herbert, who thirty years earlier served as secretary of the U.S. Navy in the Grover Cleveland administration). The plaques are inscribed:")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-para"
  }, [_vm._v("TO THE MEMORY OF OUR HEROIC COMRADES")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_vm._v("WHO GAVE THEIR LIVES FOR THEIR COUNTRY’S")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_vm._v("UNITY ON THE BATTLEFIELD THIS TABLET IS DEDICATED")]), _vm._v(" "), _c('p', {
    staticClass: "box-para1"
  }, [_vm._v("TO THE BRAVE ALABAMA BOYS,")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_vm._v("OUR OPPONENTS ON THIS FIELD OF BATTLE")]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_vm._v("WHOSE MEMORY WE HONOR THIS TABLET IS DEDICATED")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("On May 18, 1907, Herbert wrote to Edmund Burd Grubb, a former soldier in the 23rd New Jersey:")]), _vm._v(" "), _c('p', {
    staticClass: "bq1d"
  }, [_vm._v("Dear Sir:")]), _vm._v(" "), _c('p', {
    staticClass: "bq-para1"
  }, [_vm._v("A recent number of the Montgomery Ala. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Advertiser")]), _vm._v(" copies an account from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fredericksburg Star")]), _vm._v(" of May 3rd, of the erection of a “Monument to Commemorate the Services of the 23rd New Jersey Volunteer Infantry in the Battle of Salem Church, Virginia, May 3rd, 1863,” and I have noted with unmixed pleasure that… on one of the plates upon the monument are inscribed the words: To the memory of our heroic comrades who gave their lives for their country’s unity on the battlefield, this tablet is dedicated.")]), _vm._v(" "), _c('p', {
    staticClass: "bq-para"
  }, [_vm._v("Upon another plate is this inscription: To the brave Alabama boys, our opponents on this field of battle, whose memory we honor, this tablet is dedicated.")])]), _c('p', {
    staticClass: "bq-para"
  }, [_c('a', {
    attrs: {
      "id": "page4",
      "title": "4"
    }
  }, [_vm._v("I was with my regiment, the 8th Alabama, and was its Lieutenant Colonel in the bloody fight which you and your brave soldiers have so fittingly commemorated. Indeed, the 8th Alabama was on the south side of the plank road, and therefore almost immediately confronted your gallant regiment. Being the oldest surviving field officer of the five Alabama regiments that participated in the memorable struggle, I feel that I may appropriately assume, on behalf of the Alabama boys whose memory you and your brave")]), _c('a', {
    attrs: {
      "id": "page5",
      "title": "5"
    }
  }, [_vm._v(" soldiers so chivalrously extol, to extend to you and the other survivors of the 23rd New Jersey, as I do hereby, the heartfelt thanks of the living Alabamians who participated in that battle.")])]), _c('a', {
    attrs: {
      "id": "page5",
      "title": "5"
    }
  }, [_c('p', {
    staticClass: "bq-para"
  }, [_vm._v("… The brave soldiers of the 23rd New Jersey are not the first, either federal or Confederate, that have done honor to those who were their opponents in the civil war. Many an orator, thank God, both Northern and Southern, has delighted his audience by patriotic sentiments along this line. But as far as I know, the gallant regiment which you had the honor to command at Salem Church, is the first to inscribe upon an enduring monument erected to the memory of its own dead so noble a special tribute to those who were its antagonists in the particular field marked by the monument.")]), _vm._v(" "), _c('p', {
    staticClass: "bq-para"
  }, [_vm._v("In conclusion, permit me to personally testify, as I well may, to the superb courage of the gallant boys whom you so nobly led in that bloody battle at Salem Church. Expressing the hope that at some time in the future I may have the gratification of meeting you in person, I am, sir, with the sincerest admiration and respect,")]), _vm._v(" "), _c('p', {
    staticClass: "bq1d"
  }, [_vm._v("Yours very truly")]), _vm._v(" "), _c('p', {
    staticClass: "bq1d"
  }, [_vm._v("Hilary A. Herbert")]), _vm._v(" "), _c('p', {
    staticClass: "bq1"
  }, [_vm._v("last Colonel 8th Ala Vols")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Grubb replied two weeks later, acknowledging that Colonel Herbert, his wartime adversary, had served the reunited country as President Cleveland’s navy secretary three decades earlier:")]), _vm._v(" "), _c('p', {
    staticClass: "bq1d"
  }, [_vm._v("Dear Colonel Herbert,")]), _vm._v(" "), _c('p', {
    staticClass: "bq-para1"
  }, [_vm._v("It has surely fallen to the lot of but very few men in this world, ever to have received, from a brave and gallant foeman, forty-four years after a battle, such a splendid letter as I have the honor to acknowledge from you, and moreover, to have received it unaware from one, who after the war was over, served a re-united country in one of its highest offices with such signal ability and distinction.")]), _vm._v(" "), _c('p', {
    staticClass: "bq-para"
  }, [_vm._v("I beg, sir, on behalf of myself, and my comrades, the survivors of the Twenty-third New Jersey Volunteers, their descendants, relations, and friends, whose name is legion in this State, to tender our most sincere thanks for your letter, to reciprocate most heartily all the noble sentiments contained therein, and to assure you that we congratulate ourselves, that by good fortune, we happened to be the first to mark in enduring bronze, the sentiments which we are sure are uppermost in the hearts of every Northern soldier, for the men who evinced the courage of their convictions by such heroic bravery in the days gone by.")])]), _c('p', {
    staticClass: "bq-para"
  }, [_c('a', {
    attrs: {
      "id": "page5",
      "title": "5"
    }
  }, [_vm._v("I may add that while we knew that Gen Cadmus Wilcox had noted in his report of the Battle of Salem Church how gallantly Lieut. Colonel Hilary A. Herbert had rallied and")]), _c('a', {
    attrs: {
      "id": "page6",
      "title": "6"
    }
  }, [_vm._v(" fought the 8th Alabama after a disabling wound to Colonel Royston, we certainly did not know that our country was indebted for distinguished services as Secretary of the Navy to the officer whose final line of battle we could not break through.")])]), _c('a', {
    attrs: {
      "id": "page6",
      "title": "6"
    }
  }, [_c('p', {
    staticClass: "bq-para"
  }, [_vm._v("I hope, sir, I may have the pleasure of meeting you personally, and I shall have the honor of calling upon you when I am in your vicinity.")]), _vm._v(" "), _c('p', {
    staticClass: "bq"
  }, [_vm._v("With great respect, I am,")]), _vm._v(" "), _c('p', {
    staticClass: "bq"
  }, [_vm._v("Very sincerely yours,")])]), _c('p', {
    staticClass: "bq"
  }, [_c('a', {
    attrs: {
      "id": "page6",
      "title": "6"
    }
  }, [_vm._v("E. Burd Grubb"), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn_5",
      "id": "fn5"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("As Civil War veterans aged, reunions often became demonstrations of respect among patriotic countrymen—the former Billy Yanks and Johnny Rebs. One such reunion occurred in Memphis, Tennessee, on June 10, 1909, as reported in the monthly periodical of the United Confederate Veterans, the Southern fraternal counterpart to the Union veterans’ Grand Army of the Republic:")]), _vm._v(" "), _c('p', {
    staticClass: "bq-para1"
  }, [_vm._v("Tears welled in 20,000 Southern eyes, and 10,000 tongues shouted their approval when General Fred Dent Grant, son of General U. S. Grant, clasped the hand of General Clement A. Evans, commander-in-chief of the United Confederate Veterans, during the greatest Veterans’ parade ever witnessed in the South to-day.")]), _vm._v(" "), _c('p', {
    staticClass: "bq-para"
  }, [_vm._v("A moment later scores of grizzled Veterans broke from their ranks and extended their hands to grasp in friendship the hand of the son of the man they had fought against nearly half a century ago. General Grant was presented to General Evans by Mayor Malone, one of the party occupying the box in the grand stand on the Main Street side of Court Square with General Grant.")]), _vm._v(" "), _c('p', {
    staticClass: "bq-para"
  }, [_vm._v("Following the example of their leader, scarce a man in the line of march clasped General Grant’s hand and in several instances, old men bearing the battle torn banners they fought under, stopped in front of General Grant’s seat and grasped his hand while the tattered folds of the flag they bore rested across their shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "bq-para"
  }, [_vm._v("Probably no Northern man, excepting a president, has ever been the recipient of such a tremendous ovation as was accorded the son of the Northern leader to-day. Not a commanding officer in the line but what rode his mount close enough to shake hands with General Grant, and many openly shed tears at the sight.")]), _vm._v(" "), _c('p', {
    staticClass: "bq-para"
  }, [_c('a', {
    attrs: {
      "id": "page7",
      "title": "7"
    }
  }, [_vm._v("At one point in the parade, laughter and cheers were aroused by the action of a regiment of Veterans. Their leader, on catching sight of General Grant, shouted to the other aged soldiers under his command, “Come on kids. Here’s General Grant now!” With a yell the Veterans ran to shake his hand, for the time throwing the parade into confusion.")])]), _c('a', {
    attrs: {
      "id": "page7",
      "title": "7"
    }
  }), _c('p', {
    staticClass: "bq-para"
  }, [_c('a', {
    attrs: {
      "id": "page7",
      "title": "7"
    }
  }, [_vm._v("One of the most touching incidents of the morning around the reviewing stand was when the few surviving members of the immortal 600, who suffered during the war as federal prisoners, reached the General’s box."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn_6",
      "id": "fn6"
    }
  }, [_vm._v("5")]), _vm._v(" The old men were tired by their march beneath the burning sun. At sight of General Grant their leader proposed “Three cheers for General Grant.” They were given with a gusto that would have done credit to a band of college boys."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn_7",
      "id": "fn7"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("No doubt Fred Dent Grant, the son of the great Union general and U.S. president, recalled former Confederate generals Joseph E. Johnston and Simon Bolivar Buckner, pallbearers along with former Union generals Philip Sheridan and William T. Sherman at the funeral of his father on August 8, 1885. Indeed in 1909, national reconciliation and forgiveness was in its second generation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Loyalty to the United States was codified by the official organization of Confederate veterans on the eve of America’s entry into World War I, when on May 16, 1916, the United Confederate Veterans of Alabama passed a motion that was sent to President Woodrow Wilson:")]), _vm._v(" "), _c('p', {
    staticClass: "bq-para1"
  }, [_vm._v("To the President and Congress of the United States: We, the United Confederate Veterans in Reunion assembled at Birmingham, Ala., this the 16th day of May, 1916, do hereby again renew and declare our unfaltering allegiance to the government of the United States in this its hour of great international difficulties.")]), _vm._v(" "), _c('p', {
    staticClass: "bq-para"
  }, [_vm._v("We took up arms against the government, not as rebels, but to protect our homes and firesides, to preserve and maintain the principle of States’ rights; and although the arbitrament of arms was against us, we lost neither our courage, our manhood, nor our patriotism.")]), _vm._v(" "), _c('p', {
    staticClass: "bq-para"
  }, [_vm._v("To-day the remnant of the armies of the Confederate States of America does hereby offer itself, its sons, and its property upon the altar of a reunited country which we love and seek to serve, protect, and defend.")]), _vm._v(" "), _c('p', {
    staticClass: "bq-para"
  }, [_c('a', {
    attrs: {
      "id": "page8",
      "title": "8"
    }
  }, [_vm._v("We recommend that every male citizen over sixteen years of age residing in the United States and its territories be required to report immediately to the probate judge of his county or other like officer under penalty of the law and there swear allegiance to this government, pledging him loyally to support the government against any and all foes, whether internal or foreign, that may attempt to hinder or destroy the rights, property, or liberty of its people."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn_8",
      "id": "fn8"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Reconciliation and memorialization of the former combatants continued into the latter part of the twentieth century, and as late as 1977 a monument was erected near Selma, Alabama, to honor Union soldiers killed more than a century earlier. The Alabama chapter of the United Daughters of the Confederacy, an organization of female descendants of Confederate veterans, erected a monument to honor twelve Union soldiers killed in the April 1, 1865, Battle of Ebenezer Church.")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many descendants of Confederate veterans demonstrated their patriotism by service to the reunited nation, while some proved their loyalty by giving their own lives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lieutenant General Simon Bolivar Buckner Jr., son of Confederate Major General Simon Bolivar Buckner, died on Okinawa in World War II on June 18, 1945, the highest-ranking U.S. military officer to be killed in action in the war. The great-grandson of Confederate Lieutenant General Thomas J. “Stonewall” Jackson, Colonel Thomas Jonathan Jackson Christian of the U. S. Army Air Corps was killed in action over northern France on August 12, 1944. Likewise, U.S. Army Brigadier General Nathan Bedford Forrest III, great grandson of the famous Confederate cavalryman, was killed in action leading a bombing raid on a German submarine base on June 14, 1943. At the time of his death, Forrest was chief of staff of the U.S. Second Air Force.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Legendary United States Marine Corps Lieutenant General Lewis “Chesty” Puller was a descendent of Confederates, as was former Commandant of the Marine Corps, Lieutenant General John Archer Lejeune, namesake of Camp Lejeune, North Carolina. John Archer Lejeune’s father Ovide Lejeune was a Confederate officer. The legendary World War II General George Patton was a grandson of Confederate Colonel George Smith Patton of the 22nd Virginia "), _c('a', {
    attrs: {
      "id": "page9",
      "title": "9"
    }
  }, [_vm._v("Infantry Regiment, who was mortally wounded at the Third Battle of Winchester (Virginia) on September 19, 1864.")])]), _c('a', {
    attrs: {
      "id": "page9",
      "title": "9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Other famous Americans purported to have Confederate ancestors include Presidents Bill Clinton and Harry Truman, Senator John McCain, Governor Rick Perry of Texas, and Supreme Court Justice Sandra Day O’Connor. Celebrities Anderson Cooper, Robin Williams, Larry Hagman, Will Rogers, Muppets creator Jim Henson, and iconic Hollywood director Cecil B. Demille are said to be descendants of Confederates. Performers Elvis Presley, Trace Adkins, Hank Williams, Hank Williams Jr., and Charlie Daniels ostensibly descend from Confederate soldiers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The founder and first president of the Girl Scouts of America, Juliette “Daisy” Gordon Low was the daughter of Confederate Captain William Washington Gordon. The Reverend Billy Graham and his son Franklin Graham descend from Private William Cook Graham of the 11th South Carolina Infantry Regiment. Helen Keller was the granddaughter of a Confederate colonel, and Audie Murphy, the most decorated American soldier in World War II, is also said to have descended from Confederates, as was Nobel Prize winning author William Faulkner, whose great grandfather was Colonel William Clark Falkner [sic] of the 2nd Mississippi Infantry Regiment.")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In early 2020 it remains to be seen if monuments honoring the men who fought in the American Civil War will survive the ever-changing standards of worthiness. Many Confederate monuments and landmarks are being removed, and even memorials to some Union commanders have fallen prey to fluid values.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page9",
      "title": "9"
    }
  }, [_vm._v("The strict reconsideration of characters and events doesn’t only befall those related to the Civil War. In April 2019 the state of Maine renamed Columbus Day as Indigenous People’s Day, following Alaska, Vermont, and South Dakota in no longer honoring the Spanish-Italian explorer Christopher Columbus as the symbolic discoverer of the Western Hemisphere in 1492. Also in 2019, George Washington High School in San Francisco decided to destroy a seventy-year old mural depicting the school’s namesake George Washington, once universally considered by American school children as “The Father of our Country.” Similarly, the same year the City of Charlottesville, Virginia, decided to no longer celebrate the birthday of Washington’s fellow Founding Father Thomas Jefferson, the principal author of the Declaration of Independence and the third president of the United States and founder of the University of Virginia. The city instead will")]), _c('a', {
    attrs: {
      "id": "page10",
      "title": "10"
    }
  }, [_vm._v(" celebrate the day the Union army entered and occupied Charlottesville in the waning days of the Civil War.")])]), _c('a', {
    attrs: {
      "id": "page10",
      "title": "10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In August 2017, a statue of Revolutionary War hero Colonel William Crawford was decapitated in Bucyrus, Ohio. Crawford had served under George Washington in the Continental Army in New York and New Jersey and later commanded colonial troops in battles against Native Americans in northern Ohio. In 1782 he was captured by Delaware Indians, tortured, and burned alive. Also in August 2017 a statue of “the Great Emancipator” Abraham Lincoln was vandalized in Chicago, perhaps because his 1863 Emancipation Proclamation freed only some, but not all, of the slaves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The presence of the tomb of Ulysses S. Grant in New York City has been targeted for reconsideration by the city, due, supposedly, to his anti-Semitism. A statue of early twentieth century president William McKinley was removed by the city government of Arcata, California, in 2018 because of McKinley’s imperialistic views. Similarly, in 2009 Alaska’s Mt. McKinley, North America’s highest mountain, was renamed Denali. Even a statue of famous World War II-era patriotic singer Kate Smith was removed from a public location in Philadelphia because she had recorded songs in the 1930s with racially insensitive lyrics. Smith’s iconic rendition of God Bless America, a staple at New York Yankees’ home games since the terrorist attacks of September 11, 2001, was silenced in 2018 because of those songs she had recorded so long ago.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Honors and recognition bestowed upon all historic American figures are currently under pressure the entirety of their lives, and their contributions to humanity seemingly soiled by their imperfections as judged by standards 200 years hence.")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Fuller Story is a program instituted in the historic city of Franklin, Tennessee, in 2017, in response to the then-accelerating nationwide movement of reassessing national and local historic monuments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On November 30, 1864, Franklin was the site of one of the bloodiest battles in American military history when Confederate General John Bell Hood’s 20,000-strong Army of Tennessee attacked an equal number of entrenched defenders under the command of Union General John McCallister Schofield. In just five hours of intense combat, nearly 10,000 Union and Confederate soldiers were killed or wounded—casualties that rivaled in intensity the more famous World War II battles of Normandy and Iwo Jima.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page10",
      "title": "10"
    }
  }), _c('a', {
    attrs: {
      "id": "page11",
      "title": "11"
    }
  }, [_vm._v("In 1899, the United Daughters of the Confederacy erected a statue in the Franklin town center honoring the personal sacrifices made by Confederate soldiers. In 2017, local activists called for a reassessment of the appropriateness of the statue’s presence. After much reasoned debate and consideration, representatives of the Fuller Story movement, the local history and preservation community, and the City of Franklin realized that removing the statue would effectively erase history, resulting in a “lesser story.” Instead, it was realized that a fuller story would best tell Franklin’s remarkable history.")])]), _c('a', {
    attrs: {
      "id": "page11",
      "title": "11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Recognizing the wisdom and utility of Franklin, Tennessee’s “Fuller Story” concept, the former Confederates featured in the following pages likewise have stories fuller than their lives in the four years of the American Civil War.")]), _vm._v(" "), _c('p', {
    staticClass: "fn-border"
  })]), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "page11",
      "title": "11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn2",
      "id": "fn_2"
    }
  }, [_vm._v("1")]), _vm._v(" For information on Teddy Roosevelt’s relatives, see: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://opinionator.blogs.nytimes.com/2014/06/25/teddy-roosevelts-confederate-uncles/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://opinionator.blogs.nytimes.com/2014/06/25/teddy-roosevelts-confederate-uncles/")])])])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn3",
      "id": "fn_3"
    }
  }, [_vm._v("2")]), _vm._v(" This statue, “The Soldiers Memorial Fountain,” is located in Ocean Park in Oak Bluffs.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn4",
      "id": "fn_4"
    }
  }, [_vm._v("3")]), _vm._v(" Marcus B. Toney, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Privations of a Private: Campaigning with the First Tennessee, C.S.A., and Life Thereafter")]), _vm._v(" (Fire Ant Books, 1905), 123.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn5",
      "id": "fn_5"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York Times,")]), _vm._v(" July 13, 1913.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn6",
      "id": "fn_6"
    }
  }, [_vm._v("5")]), _vm._v(" The Immortal Six-hundred were 600 Confederate officers who were prisoners of war and refused to take the oath of allegiance to the United States. They were subjected to intentionally harsh treatment by their Union captors and became a symbol of sacrifice and resolve in the South, both during and after the war.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn7",
      "id": "fn_7"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://archive.org/stream/minutesucv190910unit/minutesucv190910unit_djvu.txt",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://archive.org/stream/minutesucv190910unit/minutesucv190910unit_djvu.txt")])])]), _vm._v(", accessed August 14, 2019; page 15 of the minutes of the nineteenth meeting of the United Confederate Veterans, Memphis, TN, June 8-10, 1909.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn8",
      "id": "fn_8"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Confederate Veteran,")]), _vm._v(" 40 vols. (May 1916), vol. 24, 243.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46afe7d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Introduction.vue
// module id = 78
// module chunks = 0